import { type DataObject, type DataObjectList } from './DataObject'
import type { SurveyChoice } from './Survey'

export enum DivisionCategory {
  University = 'University',
  College = 'College',
  School = 'School',
  Department = 'Department',
  Course = 'Course',
  Section = 'Section'
}

export interface DivisionResponse {
  defaultId: string
  divisionHierarchy: Division[]
  default_id?: string
}

interface IAttribute {
  title: string
  value: string
}

export interface Division {
  categoryId?: string
  createdOn: string
  modifiedOn: string
  divisionId: string
  createdBy: string
  createdByUsername: string
  modifiedBy: string
  modifiedByUsername: string
  ownedBy: string
  categoryName: DivisionCategory
  title: string
  descr: string
  children: Division[] | null
  abbreviation: string
  parent: {
    divisionId: string
    title: string
  }
  attributes?: IAttribute[]
  childrenCategory: {
    childCategoryId: string
    childCategoryName: string
  }
}
export interface InstructorDetails {
  title: string
  instructorId: string
  instructorName: string
  id: string
}

export interface SurveyCompletionRate extends Omit<Division, 'children' | 'divisionId'> {
  completionCount: number
  childrenCount: number
  studentCount: number
  children: SurveyCompletionRate[]
  divisionId?: string
  sectionId?: string
  instructorDetails: InstructorDetails[]
  termId?: string
  crosslistedAbbrevs?: string | null
  surveyScore?: number | null
}

export interface SurveyChoiceCounts extends SurveyChoice {
  count: number
}

export type IDivisionRow = Division

export type IDivisionList = DataObject<Division>

export type IDivisionRowDataType = IDivisionList[]

export type IDivision = DataObjectList<Division>
